import React, { FC } from 'react';
import { AVideo } from '../../atoms/AVideo/index';
import { MButtonOverlay } from '../MButtonOverlay/index';
import Styled from './MVideoBackground.styles';
import type { MVideoBackgroundProps } from './MVideoBackground.types';
import { MVideoBackgroundButtonPosition } from './MVideoBackground.types';

const COMPONENT_NAME = 'm-video-background';
const TEST_ID = 'web-ui-kit-MVideoBackground';

export const MVideoBackground: FC<MVideoBackgroundProps> = ({
  buttonPosition = MVideoBackgroundButtonPosition.Bottom,
  aVideo,
  mButtonOverlay,
  className,
  ...rest
}) => {
  const hasOverlay = mButtonOverlay?.imageOverlay === true;

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className} {...rest}>
      <Styled.VideoContainer>
        <AVideo {...aVideo} />
      </Styled.VideoContainer>
      {hasOverlay && mButtonOverlay && (
        <Styled.OverlayContainer buttonPosition={buttonPosition}>
          <MButtonOverlay {...mButtonOverlay} />
        </Styled.OverlayContainer>
      )}
    </Styled.Wrapper>
  );
};

export * from './MVideoBackground.types';
